import styled from 'styled-components';
import { Medium, SemiBold } from '../../apps/styles/common-style';

// Define your styled component
export const KnowledgeCenterStyle = styled.div`
  .mat-form-field-wrapper {
    margin: 0px;
    padding-bottom: 24px;
  }

  .mat-autocomplete-panel {
    max-height: 0% !important;
  }

  .mat-form-field-appearance-outline .mat-form-field-infix {
    padding: 8px 0 16px 0;
    border-top: 1em solid transparent;
  }

  .mat-autocomplete-panel:not([class*='mat-elevation-z']) {
    margin-top: 3px;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.15);
  }

  .mat-form-field-label-wrapper {
    top: -1.1em;
  }

  .mat-form-field-appearance-outline .mat-form-field-prefix {
    top: 0.38em !important;
  }

  .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
    color: $blue;
  }

  .mat-option-text {
    font-family: ${Medium};
  }

  .mat-drawer-backdrop.mat-drawer-shown {
    background-color: rgba(45, 45, 57, 0.5); /* or your defined color variable */
  }

  .business-glossary {
    word-break: keep-all;
    padding: 10px;
    width: 354px;
    margin-top: -25px;
    height: 100%;

    .title {
      color: #2d2d39;
      font-family: ${Medium};
      font-size: 22px;
      text-align: center;
    }

    .path {
      float: left;
      color: #757588;
    }

    &-header {
      text-align: center;
    }

    &-form {
      mat-form-field {
        width: 100%;
        mat-form-field-flex {
          border: 1px solid #b3babc;
          border-radius: 5px;
        }
      }
    }

    .input-style {
      height: 0 !important;
      padding: 0 !important;
    }
  }

  .glossary-title-react {
    color: #2d2d39;
    word-break: keep-all;
    font-family: ${SemiBold};
    font-size: 28px;
    line-height: 32px;
    letter-spacing: 0.2px;
  }

  .all-metrics-glossary-title {
    color: #2d2d39;
    font-family: ${SemiBold};
    letter-spacing: 0.2px;
    font-size: 18px;
    line-height: 22px;
    word-break: keep-all;
  }

  .glossary-formula {
    color: #2d2d39;
    font-family: ${SemiBold};
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 22px;
    margin-top: 32px;
    margin-bottom: 8px;
  }

  .glossary-definition {
    word-break: keep-all;
    color: #2d2d39;
    font-family: ${Medium};
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 22px;

    .bullet {
      list-style-type: disc;
      margin-left: 20px;
    }

    ul {
      list-style: disc;
      list-style-position: outside;
      margin-left: 20px;
    }

    ol {
      list-style: decimal;
      list-style-position: inside;
      margin-left: 20px;
    }
  }

  .glossary-definition-tag {
    color: #196ecf;
    text-decoration: none;
  }

  .go-to-metric-location {
    color: #196ecf;
    font-family: ${Medium};
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 22px;
  }

  .icon-search-black {
    height: 24px;
    width: 24px;
  }

  .oval {
    height: 40px;
    width: 40px;
  }

  .metrics-div {
    min-height: 92%;
    word-break: break-all;
    padding-bottom: 90px;
    padding-top: 23px;
  }

  .view-all-metrics-title {
    color: #2d2d39;
    font-family: ${SemiBold};
    font-size: 28px;
    line-height: 32px;
    padding-top: 6px;
    padding-bottom: 25px;
  }

  .each-metric-border {
    border-top: 1px solid #e0e0e0;
    padding-top: 22px;
  }

  .each-metric-div {
    padding-bottom: 9px;

    .glossary-metric-content-div {
      height: 44px;
      overflow: hidden;
    }
  }

  .Read-More {
    color: #196ecf;
    font-family: ${Medium};
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.2px;
    line-height: 22px;
    padding-bottom: 25px;

    &:hover {
      cursor: pointer;
    }
  }

  .view-allMetrics {
    color: #196ecf;
    cursor: pointer;
    font-family: ${Medium};
    font-size: 16px;
    letter-spacing: 0.2px;
    padding: 18px 0 18px 18px;
  }

  .view-all-metrics-button-position-div {
    position: fixed;
    bottom: 0;
    right: 0;
  }

  .view-all-metrics-button-div {
    background: #ffffff;
    margin-left: -24px;
    padding-left: 31px;
    padding-right: 32px;
    padding-bottom: 25px;
    padding-top: 25px;
  }

  .view-all-metrics-button {
    box-sizing: border-box;
    height: 41px;
    width: 354px;
    border: 1px solid #196ecf;
    border-radius: 2px;
    text-align: center;
    padding-top: 8px;
    padding-bottom: 8px;

    &:hover {
      background-color: #196ecf;
      cursor: pointer;

      .view-all-metrics-button-text {
        color: white !important;
      }
    }
  }

  .view-all-metrics-button-text {
    color: #196ecf;
    font-family: ${Medium};
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 22px;
    text-align: center;
  }

  .cdk-overlay-pane {
    transform: none !important;
    /* left: 59.11% !important;
    top: 60.85% !important; */
  }

  .network-lever-ul {
    padding-left: 30px;

    li {
      list-style-type: disc;
    }
  }

  .margin-top-5 {
    margin-top: 5px;
  }

  .bg-spinner {
    position: absolute !important;
    left: 45%;
  }

  .e-rte-anchor {
    cursor: pointer;
    color: #196ecf !important;
    text-decoration: none !important;
  }

  .glossary-auto-complete {
    transform: translateX(16px);
  }

  .metric-indicator {
    font-family: ${Medium};
    font-size: 14px;
    letter-spacing: 0.2px;

    &-external,
    &-internal {
      width: 62px;
      display: inline-flex;
      height: 20px;
      justify-content: center;
      align-items: center;
    }

    &-external {
      border: 1px solid #196ecf;
      border-radius: 2px;
      background-color: #e3f0fd;
      margin-right: 6px;
    }

    &-internal {
      border: 1px solid #0d880b;
      border-radius: 2px;
      background-color: #e1fadf;
    }
  }
  .autocomplete-section {
    margin: 0.25em 0;
    padding-bottom: 1.34375em;
  }

  p,
  ol,
  ul {
    margin: 0;
    padding: 0;
  }
  .breadcrumb-bdr {
    border-bottom: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .KC-breadcrumb li {
    display: inline-flex;
    font-size: 14px;
    font-family: ${Medium};
    padding-right: 4px;
    line-height: 18px;
  }
  .KC-breadcrumb .text-link {
    color: #196ecf;
    cursor: pointer;
    text-decoration: underline;
    font-size: 14px;
    font-family: ${SemiBold};
  }
  .KC-breadcrumb .disable-link {
    color: #757588 !important;
    text-decoration: none;
    font-family: ${Medium};
  }
  .disable-arrow {
    user-select: none;
    background-repeat: no-repeat;
    display: inline-block;
    fill: currentColor;
    overflow: hidden;

    color: #757588;
    padding-left: 4px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    font-family: ${Medium};
  }
  .disable-arrow:focus-visible {
    outline: -webkit-focus-ring-color auto 1px;
  }
  .go-metric-location {
    font-size: 16px;
    font-family: 'UHCSans-SemiBold', Helvetica, Arial, Verdana, Tahoma, sans-serif;
    line-height: 22px;
    color: #196ecf;
    cursor: pointer;
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
  .go-metric-location svg {
    padding-left: 7px;
  }
`;
